export const HUNT_PACKAGE_MAX = 25
export const HUNT_MAX = 25
export const API_KEYS_MAX_KEYS = 20
export const HUBSPOT_API_BASE_URL = 'https://api.hubapi.com'
export const HUBSPOT_ADD_COMPANY_ENDPOINT =
  'https://api.hubapi.com/crm/v3/objects/companies'
export const HUBSPOT_ADD_CONTACT_ENDPOINT =
  'https://api.hubapi.com/crm/v3/objects/contacts'
export const HUBSPOT_SEARCH_COMPANY_ENDPOINT =
  'https://api.hubapi.com/crm/v3/objects/companies/search'
